import BuildingType from '@/roc/building/BuildingType';
import BuildingMaxLevel from '@/roc/building/BuildingMaxLevel';
import Effects from '@/roc/effects/Effects';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const CompactCultureSite = {
  id: '19',
  name: 'Compact Culture Site',
  width: 2,
  height: 1,
  type: BuildingType.CULTURE,
  era: 'stoneAge',
  icon: 'Culture_Range',
  minLevel: 1,
  maxLevel: BuildingMaxLevel.ONE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Culture_Sites/Compact_Culture_Site',
  flags: 0,
  counts: {
    stoneAge: 4,
    bronzeAge: 5,
    minoanEra: 6,
    classicGreece: 7,
    earlyRome: 8,
    romanEmpire: 8,
    byzantineEra: 9,
    ageOfTheFranks: 9,
    feudalAge: 9,
    iberianEra: 9,
    kingdomOfSicily: 9,
    highMiddleAges: 9,
    earlyGothicEra: 9,
    lateGothicEra: 9,
  },
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerLevel([100, 120, 140, 160, 180, 220, 260, 300, 360, 420, 500, 600, 700, 800]),
      CultureRange.asFlat(1),
    ),
  ]),
};

export default CompactCultureSite;
